import { Injectable } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class StudioService {
  entity: string = "/studios";

  constructor(private http: HttpClient, private authService: AuthService) {}

  custom_delete(studio: string): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/custom-delete",
      { studio: studio },
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  get(): Observable<any> {
    const token = this.authService.currentUserValue?.token;
    let profile = this.authService.currentUserValue.is_connect_with
      ? "&profile=" + this.authService.currentUserValue?.profile?.id
      : "";

    const options = token
      ? {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        }
      : {};

    return this.http.get(
      environment.api + this.entity + "?pagination[pageSize]=1000" + profile,
      options
    );
  }

  get_one(id: string): Observable<any> {
    return this.http.get(environment.api + this.entity + "/" + id, {});
  }

  get_final_price(body: any): Observable<any> {
    return this.http.post(environment.api + "/custom/calcule-price", body);
  }

  get_price_fees(): Observable<any> {
    return this.http.get(environment.api + "/simulator");
  }

}
